import IconButton, { IconButtonVariants, } from '@polestar/component-warehouse-react/components/icon-button/IconButton';
import React, { createContext, forwardRef, useContext } from 'react';
import { AnimatePresence, m as motion } from 'framer-motion';
import { createTransition, MotionDurationsSeconds, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import styled from '@emotion/styled';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import { css } from '@emotion/react';
const VideoPlayerActionButton = forwardRef(({ icon, ...props }, ref) => {
    const { transparent } = useVideoPlayerActionButtonController();
    return (React.createElement(VideoPlayerActionButtonContainer, null,
        React.createElement(AnimatePresence, null,
            React.createElement(motion.div, { key: transparent ? 'transparent' : 'opaque', transition: createTransition({ duration: MotionDurationsSeconds.xSlow }), initial: { opacity: transparent ? 0 : 1 }, animate: { opacity: 1 }, exit: { opacity: 0, position: 'absolute' }, style: { marginInlineStart: Spacings.small } },
                React.createElement(StyledActionIconButton, { ...props, ref: ref, icon: icon, variant: transparent ? IconButtonVariants.transparent : IconButtonVariants.followTheme, transparent: transparent })))));
});
VideoPlayerActionButton.displayName = 'VideoPlayerActionButton';
export default VideoPlayerActionButton;
/**
 * @internal
 */
export const VideoPlayerActionButtonContext = createContext({
    transparent: false,
});
const useVideoPlayerActionButtonController = () => useContext(VideoPlayerActionButtonContext);
const VideoPlayerActionButtonContainer = styled.div `
  position: relative;
`;
const StyledActionIconButton = styled(IconButton, shouldNotForwardProps(false, 'transparent'))(({ theme, transparent }) => {
    const base = transparent
        ? theme.videoPlayer.actionButton.transparent
        : theme.videoPlayer.actionButton;
    return css `
    color: ${base.states.enabled.labelColor};
    background-color: ${base.states.enabled.backgroundColor};

    &:hover {
      color: ${base.states.hover.labelColor};
      background-color: ${base.states.hover.backgroundColor};
    }
  `;
});
